<template>
    <li class="p-16 shadow-sm rounded mb-16 last:mb-0 bg-white">
        <div class="flex items-center leading-none">
            <tag
                class="mr-12 bg-semantic-warning font-semibold"
                v-if="checkIfTrue"
            >
                {{ $t('general.new') }}
            </tag>
            <tag
                v-if="announcement.announcement_tag"
                class="mr-12"
                :style="{'background-color': announcement.announcement_tag.color}"
            >
                {{ announcement.announcement_tag.title }}
            </tag>
            <p class="mt-1 text-primary-80 items-center text-body-sm uppercase">{{ moment(announcement.created_at).locale(locale).format("LL") }}</p>
        </div>
        <h3 class="font-semibold mt-16 mb-16 text-body">
            {{ announcement.title }}
        </h3>
        <p>
            <span class="announcement-description" v-html="announcement.description"></span>
        </p>
        <div v-if="hasUrl" class="flex justify-end mt-32">
            <simple-button
                display="secondary"
                :href="announcement.info_path"
                look="primary"
                icon="keyboard-arrow-right"
                small
                target="_blank"
                type="link"
            >
                {{ $t('general.read_more') }}
            </simple-button>
        </div>
    </li>
</template>

<script>
import Announcement from '../../models/Announcement';
import moment from 'moment';
import SvgIcon from './SvgIcon.vue';
import Tag from "./Tag.vue";
import SimpleButton from "./SimpleButton.vue";
import {mapStores} from "pinia";
import {useMainStore} from "../../state/store";

export default {
    props: {
        announcement: Announcement,
    },
    data: function () {
        return {
            moment,
            checkIfTrue: moment().local().isBefore(moment(this.announcement.created_at).add(14, 'days')),
            hasUrl: this.announcement.info_path,
        }
    },
    computed: {
        ...mapStores(useMainStore),
        locale() {
            return this.mainStore.locale;
        },
        datetimeFormat() {
            return this.mainStore.datetimeFormat;
        },
    },
    components: {
        SimpleButton,
        Tag,
        'svg-icon': SvgIcon,
    },
}
</script>
<style>
    .announcement-description {

        & ul {
            @apply list-disc pl-24;
        }

        & ol {
            @apply list-decimal pl-24;
        }

        & figure {
            @apply pt-16 mb-16 mx-auto flex justify-center text-center;

            & img {
                @apply shadow-sm;
            }

            & a {
                @apply no-underline text-primary-80;
            }
        }

        & figcaption {
            @apply pt-4;
        }
    }
</style>
